<template>
  <div class="container">
    <div class="navi">
        <span class="close"><span class="icon-arrow-left" @click="$router.go(-1)"></span></span>
        <div class="top-title">停车位状态解释</div>
        <span></span>
    </div>
    <div class="vehicle-img">
        <img src='../../assets/img/clean/parking_tutorial.gif'>
    </div>
  </div>
</template>

<script>
export default {
  name: 'parking',
}

</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.container{
    padding-top:60px;
}
.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    position:fixed;
    top:0;
    width:100%;
    background:rgba(255, 255, 255, 0.9);
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:12px;
            display:inline-block;
        }
    }
    .icon-arrow-left{
        padding-left:12pt;
    }
    .top-title{
        font-size:0.5em;
        line-height:3.2em;
        color:#444;
        vertical-align:top;
        display:inline-block;
        text-align:center;
    }
}

.vehicle-img img{
    max-width:100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/clean/parking.vue